export const rolesHistChartConfig = (title: string, xAxisData: string[], seriesData: number[]) => ({
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow"
    }
  },
  toolbox: {
    show: true,
    right: 20,
    feature: {
      saveAsImage: {
        title: title,
        backgroundColor: "transparent"
      }
    }
  },
  legend: {
    orient: "horizontal",
    bottom: 0
  },
  xAxis: {
    type: "category",
    data: xAxisData
  },
  yAxis: {
    type: "value"
  },
  series: [
    {
      type: "bar",
      data: seriesData,
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.2)"
        }
      }
    }
  ]
});
